// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/attachment_kind.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/attachment_kind.proto.
 */
export const file_studyo_today_planners_v1_resources_attachment_kind = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2F0dGFjaG1lbnRfa2luZC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyq7AQoOQXR0YWNobWVudEtpbmQSHwobQVRUQUNITUVOVF9LSU5EX1VOU1BFQ0lGSUVEEAASGAoUQVRUQUNITUVOVF9LSU5EX0xJTksQARIYChRBVFRBQ0hNRU5UX0tJTkRfRklMRRACEh8KG0FUVEFDSE1FTlRfS0lORF9TSEFSRURfRklMRRADEhgKFEFUVEFDSE1FTlRfS0lORF9GT1JNEAQSGQoVQVRUQUNITUVOVF9LSU5EX1ZJREVPEAVCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.AttachmentKind.
 */
export const AttachmentKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_attachment_kind, 0);

/**
 * All general kinds of attachments supported by the system.
 *
 * @generated from enum studyo.today.planners.v1.resources.AttachmentKind
 */
export const AttachmentKind = /*@__PURE__*/
  tsEnum(AttachmentKindSchema);

